<template>
  <div
    class="bor-cor-page"
    :style="borCorData ? {
      top: borCorData.triggerData.top + 'px',
      left: borCorData.triggerData.left + 'px'
    } : {}"
  >
    <borCorCP
      v-if="borCorData"
      v-bind="borCorData.options || {}"
      @leave="() => setBorCorAction()"
    >
      <div slot="trigger">
        <div
          class="bor-cor-container"
          :style="{
            width: borCorData.triggerData.width + 'px',
            height: borCorData.triggerData.height + 'px'
          }"
        ></div>
      </div>
      <div slot="content">
        <div v-if="(borCorData.content || {}).html" v-html="(borCorData.content || {}).html"></div>
        <component v-else-if="(borCorData.content || {}).component" :is="(borCorData.content || {}).component" :param="(borCorData.content || {}).param"></component>
      </div>
    </borCorCP>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import borCorCP from '../tool/borCor.vue'
// borCor

export default {
  components: {
    borCorCP
    // borCor
  },
  data () {
    return {
      borCorData: null
    }
  },
  computed: {
    ...mapGetters([
      'borCor'
    ])
  },
  watch: {
    'borCor' (nv) {
      this.borCorData = nv ? {
        ...nv,
        triggerData: nv.e.target.getBoundingClientRect()
      } : null
    }
  },
  methods: {
    ...mapActions([
      'setBorCorAction'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/borCor.vue